import React from 'react';
import SiteSimulator from './components/SiteSimulator';

function App() {
  return <SiteSimulator />;
}

export default App;
